import React, { useState, useEffect } from 'react';
// import PropTypes from 'prop-types';
import DeliveryAddressSection from './DeliveryAddressSection';
import SupplierSection from './SupplierSection';
import ReactLoading from 'react-loading';
import LocalizedMessage from 'react-l10n';
import { getTranslation } from '../../lang/main';
import { convertFilteredSuppliersToAReadableFormat } from '../../selectors/converterSelector';
import {
    axiosRequestFilteredSuppliers,
    axiosUpdateAccountHolderInformation,
} from '../../actions/userActions';
import { validateForm } from '../../selectors/defaultSelectors';
import { handleAxiosErrors } from '../../_utils';
import {
    createModal,
    hideModal,
    showModal,
} from '../../dom/components/confirm-removal-modal';
import { getAddressList } from '../../selectors/addressSelector';

function SelectDeliverySupplierModal(props) {
    const {
        userIsLoading,
        loggedIn,
        memberType,
        orderOnBehalf,
        user,
        initialized,
        userAddresses,
        requestInfo,
        requestSupplierAddresses,
        fullAddressList,
        supplierInfo,
    } = props;

    // const showResellerField =
    //     orderOnBehalf === false && memberType != 'wholesaler' && memberType != 'retail-customer';

    const showResellerField = window.location.href.includes('account/details');

    const [isValidated, setIsValidated] = useState(false);
    const [existingSupplierList, setExistingSupplierList] = useState([]);
    const [newSupplierList, setNewSupplierList] = useState([]);

    const [supplierAddresses, setSupplierAddresses] = useState([]);

    const [isLoading, setIsLoading] = useState({
        deliveryAddress: false,
        supplier: false,
        submit: false,
    });

    const [formData, setFormData] = useState({});

    let finalFormData = {
        DeliveryAddressID: user.defaultDeliveryAddressID,
        ParentID: user.selectedParentID,
        ...formData,
    };

    // do this for easy form validation
    let fieldRefs = {};

    const toggleLoading = (key, value) => {
        setIsLoading((prevState) => {
            // console.log('IsLoading Data:', {
            //     ...prevState,
            //     [key]: value,
            // });

            return {
                ...prevState,
                [key]: value,
            };
        });
    };

    const handleFormUpdate = (e) => {
        updateField(e.target.name, Number(e.target.value));
    };
    const handleFormUpdateBillingAddress = (e, v) => {
        if (e) {
            updateField('DeliveryAddressID', e.value);
        }
    };
    const handleFormDeliveryAddressLabel = (e, v) => {
        if (e) {
            updateField(e, v);
        }
    };
    const handleFormInputValue = (e, v) => {
        if (e) {
            updateField(e, v);
        }
    }
    const updateField = (key, value) => {
        setFormData((prevState) => {
            console.log('Field Data:', {
                ...prevState,
                [key]: value,
            });

            return {
                ...prevState,
                [key]: value,
            };
        });
    };

    // Effects
    // --------------------
    // - Update delivery address loading
    useEffect(() => {
        toggleLoading(
            'deliveryAddress',
            Object.values(userIsLoading).some((item) => item === true)
        );
    }, [userIsLoading]);

    // - Request supplier whenever address is updated
    useEffect(() => {
        if (loggedIn && initialized && finalFormData.DeliveryAddressID > 0 && showResellerField) {
            // Request supplier
            requestSuppliers();
        }
    }, [finalFormData.DeliveryAddressID, initialized]);

    // - Request supplier address whenever supplier is updated
    useEffect(() => {
        if (loggedIn && initialized && finalFormData.ParentID > 0) {
            if (typeof supplierInfo[finalFormData.ParentID] == 'undefined') {
                requestSupplierAddresses(finalFormData.ParentID);
            }
        }
    }, [finalFormData.ParentID, initialized]);

    // - Update the set supplier address list
    useEffect(() => {
        if (loggedIn && initialized && finalFormData.ParentID > 0) {
            if (typeof supplierInfo[finalFormData.ParentID] != 'undefined') {
                const supplier = supplierInfo[finalFormData.ParentID];
                setSupplierAddresses(
                    getAddressList(supplier.Addresses, fullAddressList)
                );
            }
        }
    }, [finalFormData.ParentID, initialized, supplierInfo]);

    // - Validate form
    useEffect(() => {
        let status = !validateForm(fieldRefs);

        if (userAddresses.length <= 0 && supplierAddresses.length <= 0) {
            status = false;
        }

        if (showResellerField) {
            if (
                existingSupplierList.length <= 0 &&
                newSupplierList.length <= 0
            ) {
                status = false;
            }
        }

        setIsValidated(status);
    }, [finalFormData]);

    // Functions
    // --------------------
    const requestSuppliers = () => {
        toggleLoading('supplier', true);

        let payload = Number(finalFormData.DeliveryAddressID);

        axiosRequestFilteredSuppliers(payload)
            .then((response) => {
                const completeList = convertFilteredSuppliersToAReadableFormat(
                    response.data.data.readMemberFilteredSuppliers
                );
                const userPreferredSupplierIDs = {};

                if (
                    typeof user.PreferredSuppliers != 'undefined' &&
                    user.PreferredSuppliers.length
                ) {
                    user.PreferredSuppliers.forEach((item) => {
                        userPreferredSupplierIDs[item.SupplierID] =
                            item.SupplierID;
                    });
                }

                // Break them down into existing list and new list
                let hasPreviouslySelectedID = false;
                let existingList = [];
                let newList = [];

                if (completeList.length) {
                    completeList.forEach((supplier) => {
                        const { ID } = supplier;

                        if (
                            typeof userPreferredSupplierIDs[ID] != 'undefined'
                        ) {
                            existingList.push(supplier);
                        } else {
                            newList.push(supplier);
                        }

                        if (ID == finalFormData.ParentID) {
                            hasPreviouslySelectedID = true;
                        }
                    });
                }

                // If our list is not there, remove
                if (!hasPreviouslySelectedID) {
                    updateField('ParentID', '');
                }

                // wait for async requests
                Promise.all([
                    setExistingSupplierList(existingList || []),
                    setNewSupplierList(newList || []),
                ]).then(() => {
                    toggleLoading('supplier', false);
                });
            })
            .catch(() => {
                toggleLoading('supplier', false);
            });
    };

    const updateAccountInformation = (e) => {
        toggleLoading('submit', true);

        let payload = {
            DeliveryAddressID: Number(finalFormData.DeliveryAddressID),
            ParentID: Number(finalFormData.ParentID),
        };

        if (payload.ParentID == 0) {
            delete payload.ParentID;
        }

        axiosUpdateAccountHolderInformation(payload)
            .then((response) => {
                // const userInfo = convertUserDetailedInformationToAReadableFormat(response.data.data.updateMemberInfo);

                // Only redirect if we are changing supplier, otherwise refresh the page
                if (Number(user.selectedParentID) != Number(payload.ParentID) && memberType != 'wholesaler') {
                    window.location.href = window.pathURL;
                } else {
                    window.location.reload();
                }
            })
            .catch((response) => {
                handleAxiosErrors(response);
                toggleLoading('submit', false);
            });
    };

    const handleFormSubmit = (e) => {
        e.preventDefault();

        // Only request to show modal if we are updating supplier
        if (Number(user.selectedParentID) != Number(finalFormData.ParentID) && memberType != 'wholesaler' && showResellerField) {
            const modalName = 'confirm-update-delivery-supplier-modal';
            let data = {
                heading:
                    memberType == 'retail-customer'
                        ? getTranslation(
                            'SELECT_DELIVERY_SUPPLIER_MODAL.CHANGE_RESELLER_CONFIRMATION_HEADING'
                        )
                        : getTranslation(
                            'SELECT_DELIVERY_SUPPLIER_MODAL.CHANGE_WHOLESALER_CONFIRMATION_HEADING'
                        ),
                noticeText:
                    memberType == 'retail-customer'
                        ? getTranslation(
                            'SELECT_DELIVERY_SUPPLIER_MODAL.CHANGE_RESELLER_CONFIRMATION_CONTENT'
                        )
                        : getTranslation(
                            'SELECT_DELIVERY_SUPPLIER_MODAL.CHANGE_WHOLESALER_CONFIRMATION_CONTENT'
                        ),
                content: '',
            };

            // create modal
            createModal(
                modalName,
                data,
                () => {
                    hideModal(modalName);
                    showModal('select-delivery-supplier-modal');
                    updateAccountInformation();
                },
                () => {
                    showModal('select-delivery-supplier-modal');
                }
            );

            // and hide the current one
            hideModal('select-delivery-supplier-modal');
        } else {
            updateAccountInformation();
        }
    };

    const disableChangeSupplier = supplierAddresses.some((item) => {
        return item.ID == finalFormData.DeliveryAddressID;
    });

    return (
        <React.Fragment>
            <div className='react-component'>
                <div className='vspace'>
                    <DeliveryAddressSection
                        isLoading={isLoading}
                        fieldRefs={fieldRefs}
                        handleFormUpdate={handleFormUpdate}
                        updateField={updateField}
                        handleFormInputValue={handleFormInputValue}
                        handleFormDeliveryAddressLabel={handleFormDeliveryAddressLabel}
                        handleFormUpdateBillingAddress={handleFormUpdateBillingAddress}
                        formData={finalFormData}
                        requestSupplierAddresses={requestSupplierAddresses}
                        userAddresses={userAddresses}
                        supplierAddresses={supplierAddresses}
                        requestUserInfo={requestInfo}
                        memberType={memberType}
                    />
                    {(showResellerField === true && window.memberType !== 'Reseller') && (
                        <SupplierSection
                            isDisabled={disableChangeSupplier}
                            isLoading={isLoading}
                            fieldRefs={fieldRefs}
                            handleFormUpdate={handleFormUpdate}
                            updateField={updateField}
                            formData={finalFormData}
                            existingSupplierList={existingSupplierList}
                            newSupplierList={newSupplierList}
                            memberType={memberType}
                        />
                    )}
                </div>

                <div className='button-box--center'>
                    <button
                        type='button'
                        className={`form__submit button ${!isValidated ? 'button--disabled' : ''
                            }`}
                        disabled={!isValidated}
                        onClick={handleFormSubmit}
                    >
                        {isLoading.submit == true && (
                            <ReactLoading
                                type='spin'
                                className='button__spinner'
                                color='white'
                                height={20}
                                width={20}
                            />
                        )}
                        <span style={{ opacity: isLoading.submit ? 0 : 1 }}>
                            <LocalizedMessage id={'CONFIRM'} />
                        </span>
                    </button>
                </div>
            </div>
        </React.Fragment>
    );
}

// default props
SelectDeliverySupplierModal.defaultProps = {
    // message: '',
};
// validate props
SelectDeliverySupplierModal.propTypes = {
    // message: PropTypes.string,
};

export default SelectDeliverySupplierModal;

